import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { ApiResponse, InfiniteResponse } from "../../apis/data";
import { queryKey } from "../../enumerations/queryKey";
import { cleanedParams } from "../../plugins/utils";
import {
  NewsCategoryResponse,
  NewsDetailParams,
  NewsDetailResponse,
  NewsParams,
  NewsResponse,
  PagingResponse,
} from "./data";
import {
  apiGetNewsCategory,
  apiGetNewsDetail,
  apiGetNewsList,
} from "./service";

export const useGetInfiniteNews = (params: NewsParams, options: any) => {
  const queryKeyArr = [
    queryKey.NEWS_LIST,
    ...Object.values(cleanedParams(params)),
  ];
  return useInfiniteQuery<NewsResponse[]>({
    queryKey: queryKeyArr,
    queryFn: ({ pageParam }) =>
      apiGetNewsList({ ...params, page: pageParam }).then(
        (res: ApiResponse<InfiniteResponse<NewsResponse[]>>) => {
          return res.data.data;
        }
      ),
    initialPageParam: 1,

    ...options,
  });
};

export const useGetNews = (params: NewsParams, options: any) => {
  const queryKeyArr = [
    queryKey.NEWS_LIST,
    ...Object.values(cleanedParams(params)),
  ];

  return useQuery<PagingResponse>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetNewsList(params).then((res: ApiResponse<PagingResponse>) => {
        return res.data.data;
      }),
    ...options,
  });
};

export const useGetNewsCategory = (options: any) => {
  return useQuery<NewsCategoryResponse[]>({
    queryKey: [queryKey.NEWS_CATEGORY_LIST],
    queryFn: () =>
      apiGetNewsCategory().then((res: ApiResponse<NewsCategoryResponse[]>) => {
        return res.data.data;
      }),
    ...options,
  });
};

export const useGetNewsDetail = (params: NewsDetailParams, options: any) => {
  const queryKeyArr = [
    queryKey.NEWS_DETAIL,
    ...Object.values(cleanedParams(params)),
  ];
  return useQuery<NewsDetailResponse>({
    queryKey: queryKeyArr,
    queryFn: () =>
      apiGetNewsDetail(params).then((res: ApiResponse<NewsDetailResponse>) => {
        return res.data.data;
      }),
    ...options,
  });
};
